import {
  Component,
  forwardRef,
  ViewChild,
  Input,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnChanges,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  ViewRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { isNullOrUndefined } from '../../extensions';
import { BaseComponent } from '../base.component';
import 'rxjs/add/operator/takeUntil';

@Component({
  selector: 'ig-date-field',
  templateUrl: './date.field.component.html',
  styleUrls: ['./date.field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateFieldComponent),
      multi: true,
    },
  ],
  host: {
    class: 'ig-date-field',
  },
})
export class DateFieldComponent
  extends BaseComponent
  implements ControlValueAccessor, AfterViewInit, OnChanges, OnInit
{
  private _value: Date;
  private _notifyChange: any;

  public errorText = '';
  public isDisplayErrorMessage: boolean;
  @Input() public type: 'date' | 'datetime' = 'date';
  @Input() public disabled;
  @Input() public min;
  @Input() public max;
  @Input() public label;
  @Input() public format;
  @Input() public customErrorTexts: any;
  @Input() public iconColor = '#5cbcff';
  @Input('formControl') public formControl: FormControl;
  @ViewChild('picker') public picker: any;
  @Output() change: EventEmitter<any> = new EventEmitter();

  public get value() {
    return this._value;
  }

  public set value(newValue: Date) {
    if (isNullOrUndefined(this._value) && isNullOrUndefined(newValue)) {
      return;
    }

    this._value = newValue && new Date(newValue);

    if (this._notifyChange) {
      this._notifyChange(this._value);
    }

    this.updateErrorText();
    this.detectChanges();
  }

  constructor(public changeDetector: ChangeDetectorRef) {
    super();
  }

  public ngOnInit() {
    this.updateFormat();

    if (this.formControl) {
      let oldMarkAsPristine = this.formControl.markAsPristine.bind(this.formControl);

      this.formControl.markAsPristine = (options) => {
        oldMarkAsPristine(options);
        this.isDisplayErrorMessage = false;
        this.errorText = '';
        this.detectChanges();
      };
    }
  }

  public writeValue(newValue: any): void {
    this._value = newValue;

    if (!isNullOrUndefined(newValue)) {
      this._value = new Date(newValue);
    }

    this.detectChanges();
  }

  public registerOnChange(fn: any): void {
    this._notifyChange = fn;
  }

  public registerOnTouched(fn: any): void {}

  public ngAfterViewInit(): void {
    setTimeout(() => this.writeValue(this._value));
  }

  public ngOnChanges(): void {
    if (this.min) {
      this.min = new Date(this.min);
    }

    if (this.max) {
      this.max = new Date(this.max);
    }

    this.updateFormat();
  }

  public onChange() {
    this.change.emit(this.value);
  }

  public onOpen(): void {
    // someone report the date picker fall bebind the shadow in DXP export pdf modal, so here set the zindex
    setTimeout(() => {
      const cdkContainers = document.querySelectorAll('.cdk-overlay-container');
      Array.from(cdkContainers).forEach((cdkContainer) => {
        const datepicker = cdkContainer.querySelector('md2-datepicker-content');
        if (datepicker) {
          (cdkContainer as HTMLElement).style.zIndex = '1001';
        } else {
          console.log('datepicker not found');
        }
      });
    });

    this.detectChanges();
  }

  public onKeyPress($event) {
    if ($event && $event.key === 'Enter') {
      this.picker.open();
    }
  }

  public onKeydown($event): void {
    this.picker._handleKeydown($event);
  }

  public clearValue($event): void {
    this.value = null;
    this.changeDetector.markForCheck();
    $event.stopPropagation();
  }

  public updateErrorText() {
    this.errorText = '';

    if (this.formControl && this.formControl.dirty && this.formControl.errors) {
      for (let key of Object.keys(this.formControl.errors)) {
        if (!!this.customErrorTexts) {
          let customErrorText = this.customErrorTexts[key];

          if (customErrorText) {
            this.errorText = customErrorText;
            return;
          }
        }

        switch (key) {
          case 'required':
            return (this.errorText = 'This field is required');

          case 'timeRangeOverlapped':
            return (this.errorText = 'Time range overlapped');
        }
      }
    }
  }

  private detectChanges(): void {
    setTimeout(() => {
      this.changeDetector.markForCheck();

      if (!(this.changeDetector as ViewRef).destroyed) {
        this.changeDetector.detectChanges();
      }
    });
  }

  private updateFormat() {
    if (!this.format) {
      this.format = this.type === 'date' ? 'MM-dd-yyyy' : 'MM-dd-yyyy HH:mm';
    }
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/date.time.field/date.field.component.ts